import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";

export default function UpdatePopUp({
  list,
  data,
  setPopUp,
  onSuccess,
  flage,
  updateData
}) {
  console.log("log data.....",list)
  const dispatch = useDispatch();
  var length = list.length;

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    baladiya_location: "",
  });

  const token = localStorage.getItem("nodeToken");
  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const employeeData =
        flage === false
          ? list.map((data) => ({
              employee_id: data.employee_id,
              baladiya_location: formData.baladiya_location,
              baladiya_apply_date: data.baladiya_apply_date,
              baladiya_issue_date: data.baladiya_issue_date,
              baladiya_expiry_date: data.baladiya_expiry_date,
              fees: data.fee,
            }))
          : list.map((data) => ({
              employee_id: data.employee_id,
              baladiya_location: formData.baladiya_location,
            }));

      const res = await nodeinstance.post(
        "/baladiya/updatelocation",
        employeeData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.status == true) {
        updateData()
        setPopUp(false);
        onSuccess();
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
    setLoading(false);
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center flex`}
      >
        <div className="max-w-xl w-full max-h-[35rem] min-h-[15rem] overflow-scroll  rounded-md bg-white/95 flex  flex-col py-4 px-8 relative ">
          <div className="flex justify-between items-center w-full mt-1 mb-3">
            <h1 className="text-xl font-semibold"> Update Baladiya Location</h1>
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form
            onSubmit={submitHandler}
            className="w-full flex flex-col my-4 gap-3"
          >
            <div className="flex flex-col gap-1">
              <label className="text-sm">Baladiya Location</label>
              <input
                type="text"
                className="input input-sm input-bordered"
                defaultValue={formData?.name?.toUpperCase()}
                required
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    baladiya_location: e.target.value,
                  })
                }
              />
            </div>

            <div className="flex  gap-3 mx-auto my-3 w-full px-5">
              <button
                type="submit"
                className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
              >
                <p>Submit</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
